import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faUser } from "@fortawesome/free-solid-svg-icons";
// components
import SettingsModal from "../utils/modals/settings/SettingsModal";
import ResetPassModal from "../utils/modals/settings/ResetPassModal";
import { signout } from "../utils/extra/signout";

const Header = ({ lang, auth, setAuth, removeCookies }) => {
  const dataTransalte = require(`../../translate/${lang === "AR" ? "arabic" : "english"
    }/data.json`);

  const initialData = {
    method: null,
    isShow: false,
  };

  const initialResetData = {
    isShow: false,
  };
  const username = localStorage.getItem("amar_management_name");
  const [modalHandler, setModalHandler] = useState(initialData);
  const [resetModalHandler, setResetModalHandler] = useState(initialResetData);
  const [activeNav, setActiveNav] = useState(`${window.location.pathname}`);
  const role = localStorage.getItem("amar_management_role");


  const handleActiveNav = (key) => {
    setActiveNav(() => key);
  };

  const setChangeExchange = () => {
    setModalHandler((prev) => ({
      ...prev,
      method: "exchange",
      isShow: true,
    }));
  };

  const setChangeShipment = () => {
    setModalHandler((prev) => ({
      ...prev,
      method: "shipment",
      isShow: true,
    }));
  };

  const setResetPass = () => {
    setResetModalHandler((prev) => ({
      ...prev,
      isShow: true,
    }));
  };

  if (!auth.isAuthenticated) {
    return <div></div>;
  }
  return (
    <>
      <SettingsModal
        method={modalHandler.method}
        show={modalHandler.isShow}
        onHide={() => setModalHandler(initialData)}
        lang={lang}
      />

      <ResetPassModal
        show={resetModalHandler.isShow}
        onHide={() => setResetModalHandler(initialResetData)}
        lang={lang}
      />
      <div
        className="header d-flex align-items-center"
        dir={lang === "AR" ? "rtl" : "ltr"}
        style={lang === "AR" ? { textAlign: "right" } : {}}
      >
        <Navbar className="bg-color-header py-1" expand="lg">
          <Container fluid>
            <Nav className=" my-1 header-navbar">
              <Dropdown>
                <Dropdown.Toggle id="dropdown-basic2">
                  <FontAwesomeIcon
                    icon={faGear}
                    size="xl"
                    style={{ color: "#4f758a" }}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="header-navbar-dropdown"
                  size="lg"
                  style={
                    lang === "AR"
                      ? {
                        right: "0",
                        textAlign: "right",
                      }
                      : {}
                  }
                >
                  <Dropdown.Item
                    className="header-navbar-dropdown-items"
                    onClick={setChangeExchange}
                  >
                    {dataTransalte.pages.navbar.settings.update_exchange_rate}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="header-navbar-dropdown-items"
                    onClick={setChangeShipment}
                  >
                    {dataTransalte.pages.navbar.settings.update_shipping_rate}
                  </Dropdown.Item>

                  <Dropdown.Item
                    className="header-navbar-dropdown-items"
                    onClick={setResetPass}
                  >
                    {dataTransalte.pages.navbar.settings.reset_password}
                  </Dropdown.Item>

                  {/* <Dropdown.Item className="header-navbar-dropdown-items">
                    {dataTransalte.pages.navbar.settings.change_language}
                  </Dropdown.Item> */}

                  <Dropdown.Divider />
                  <Dropdown.Item
                    className="header-navbar-dropdown-items"
                    onClick={() => signout(setAuth, removeCookies)}
                  >
                    {dataTransalte.pages.navbar.settings.signout}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
            <Nav className="my-1 d-flex flex-row align-items-center gap-2">
              <div>
                <FontAwesomeIcon
                  icon={faUser}
                  size="xl"
                  style={{ color: "#4f758a" }}
                />
              </div>
              <span className="username">{username}</span>
            </Nav>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav
                className={
                  lang === "AR" ? "me-auto my-1 gap-3" : "ms-auto my-1 gap-3"
                }
              >
                <Link
                  className={
                    activeNav === "/"
                      ? "header-link header-link-active"
                      : "header-link "
                  }
                  to="/"
                  onClick={() => handleActiveNav("/")}
                >
                  {dataTransalte.pages.navbar.links.customers}
                </Link>

                {/* <Link
                  className={
                    activeNav === "/shipments"
                      ? "header-link header-link-active"
                      : "header-link "
                  }
                  to="/shipments"
                  onClick={() => handleActiveNav("/shipments")}
                >
                  {dataTransalte.pages.navbar.links.shipments}
                </Link> */}

                {/* <Link
                  className={
                    activeNav === "/transfers"
                      ? "header-link header-link-active"
                      : "header-link "
                  }
                  to="/transfers"
                  onClick={() => handleActiveNav("/transfers")}
                >
                  {dataTransalte.pages.navbar.links.transfers}
                </Link> */}

                {(role == 'ADMIN' ? <Link
                  className={
                    activeNav === "/office"
                      ? "header-link header-link-active"
                      : "header-link "
                  }
                  to="/office"
                  onClick={() => handleActiveNav("/office")}
                >
                  {dataTransalte.pages.navbar.links.office}
                </Link> : <></>)}


                {/* <Link className="header-link " to="/">
                  {dataTransalte.pages.navbar.links.customers}
                </Link>
                <Link className="header-link " to="/">
                  {dataTransalte.pages.navbar.links.customers}
                </Link> */}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Header;
